import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import UpdateClientMarketForm from "./UpdateClientMarketForm";
import { useState } from "react";
import UpdateButtonTrigger from "../../../../../../../shared/components/button/UpdateButtonTrigger";

const UpdateClientMarketDialog = ({ market, onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<UpdateButtonTrigger />}
      title="clients.detail.tabs.markets.updateForm.title"
      description="clients.detail.tabs.markets.updateForm.description"
      content={
        <UpdateClientMarketForm market={market} onSubmitHandler={onSubmit} />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default UpdateClientMarketDialog;
